module.exports = __webpack_public_path__ + "static/photos-callout-kauai2019.dc4216e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/photos-callout-kauai2019.jpg
// module id = 1329
// module chunks = 168707334958949